import script from "./ShippingHistoryDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingHistoryDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ShippingHistoryDetail.vue?vue&type=style&index=0&id=2ceba1ec&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ceba1ec"]])

export default __exports__